module.exports = __webpack_public_path__ + "img/shoplogo.6b80d5be.svg";